import React from "react";


const Cpu = () => {

    return (
        <div className="component-box">
            <div className="inline-box">
                <img src="img/cpu-blue.png" alt="cpu" className="icon" />
                <span>CPU(メモリ/ストレージ)</span>
            </div>
            <div className="table-box">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>RAM</th>
                            <th>eMMC</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <p>Used: 1.7Gi</p>
                                <p>Free: 40Mi</p>
                                <p>Total: 1.8Gi</p>
                            </td>
                            <td>
                                <p>Total: 29.1Gi</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                {/* <div className="box-wrapper failed-wrapper">
                    <span>CPU(メモリ/ストレージ)の接続を確認できません。</span>
                    <div className="two-button-box">
                        <button className="retry">リトライ</button>
                        <button className="skip">スキップ</button>
                    </div>
                </div> */}
            </div>

        </div>

    );
};

export default Cpu;